export default __webpack_public_path__ + "static/media/BebasNeue-Regular.bc1037b6.woff2";